import { Text } from '../../r2/Text';
import { Slider } from '../../r2/Slider';
import styles from './TokenSlider.module.css';

export interface TokenSliderProps {
  category: string;
  items: {
    token: string;
    label: string;
    value: number;
    min: number;
    max: number;
    step?: number;
    unit?: string;
    onChange: (value: number) => void;
  }[];
}

export function TokenSlider({ category, items }: TokenSliderProps) {
  return (
    <div
      data-crd-id="r3.bq-token-slider"
      data-crd-layer="r3"
      className={styles.group}
    >
      <Text size="r3" weight="bold" color="n500">
        {category}
      </Text>
      <div className={styles.sliders}>
        {items.map((item) => (
          <Slider
            key={item.token}
            label={item.label}
            value={item.value}
            min={item.min}
            max={item.max}
            step={item.step}
            unit={item.unit}
            onChange={item.onChange}
          />
        ))}
      </div>
    </div>
  );
}
